import React, { Component } from "react";
import classnames from "classnames";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
// import Row from "react-bootstrap/Row";
import { Modal } from "react-responsive-modal";
import {
  PopupActionButton,
  PopupInsideButton,
} from "../../buttonReusableComponent/ButtonReusableComponent";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
  TextAreaReusableComponent,
} from "../../inputReusableComponent/InputBoxComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { vendor_reject_pending_diner } from "../../../../store/actions/dashboardAction/addingAction";
import {
  rejecting_rsvp_event_request,
  fetch_single_event_pending_data_information,
  fetch_single_event_rsvp_data_information,
} from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { edit_order_vendor_side } from "../../../../store/actions/OrderingAction/vendorOrderingAction";

const reasonData = [
  { id: 1, name: "No Seats", value: "No Seats" },
  { id: 2, name: "Walkaway", value: "Walkaway" },
  { id: 3, name: "Left Before Seating", value: "Left Before Seating" },
  { id: 4, name: "Other", value: "Other" },
];
const orderData = [
  {
    id: 1,
    name: "Close to the closing time",
    value: "Close to the closing time",
  },
  {
    id: 2,
    name: "All are some items are not available",
    value: "All are some items are not available",
  },
  { id: 3, name: "Staff not available", value: "Staff not available" },
  { id: 4, name: "Other", value: "Other" },
];

export class ReasonForCancellation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      cancelReservationData: "",
      enter_reason: "",
      diner_id: "",
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.allDataProps) !== nextState.diner_id) {
      return {
        diner_id: nextProps.allDataProps,
      };
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/

  onSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state?.diner_id;
    const eventId = this.props.allDataProps?._id;
    const vendor_id = this.props.auth.user?.VendorUser?._id;
    // if (this.props.cancelActionCall === "pendingSide") {
    //   const formData = {
    //     diner_status: "REJECTED",
    //     cancelReason:
    //       this.state.cancelReservationData === "Other"
    //         ? this.state.enter_reason
    //         : this.state.cancelReservationData,
    //   };
    //   this.props.rejecting_rsvp_event_request(
    //     formData,
    //     diner_id,
    //     vendor_id,
    //     token
    //   );
    //   this.onCloseModal();
    //   this.props.closedMainModal();
    // } else
    if (this.props.cancelActionCall === "orderCancelReject") {
      const formData = {
        order_status: 8,
        reason:
          this.state.cancelReservationData === "Other"
            ? this.state.enter_reason
            : this.state.cancelReservationData,
        id: this.props.allDataProps,
        max_time: 0,
      };
      this.props.edit_order_vendor_side(
        token,
        formData

        //onSuccess
      );
      this.onCloseModal();
      this.props.closedMainModal();
    } else if (this.props.cancelActionCall === "rsvpReject") {
      const formData = {
        event_type: this.props.allDataProps.event_type,
        event_status: "REJECTED",
        cancelReason:
          this.state.cancelReservationData === "Other"
            ? this.state.enter_reason
            : this.state.cancelReservationData,
        seat_number: this.props.allDataProps.seat_number,
        wait_time: 0,
      };
      this.props.rejecting_rsvp_event_request(
        formData,
        eventId,
        token,
        this.onRejectSuccess()
      );
    } else if (this.props.cancelActionCall === "rsvpCancel") {
      const formData = {
        event_type: this.props.allDataProps.event_type,
        event_status: "CANCELLED",
        cancelReason:
          this.state.cancelReservationData === "Other"
            ? this.state.enter_reason
            : this.state.cancelReservationData,
        seat_number: this.props.allDataProps.seat_number,
      };
      this.props.rejecting_rsvp_event_request(
        formData,
        eventId,
        token,
        this.onCancelSuccess()
      );
    } else {
      const formData = {
        diner_status:
          this.props.cancelRequest === "SeatingCancel"
            ? "CANCELLED"
            : "REJECTED",
        table_number: this.props.allDataPropsOne?.table_number,
        cancelReason:
          this.state.cancelReservationData === "Other"
            ? this.state.enter_reason
            : this.state.cancelReservationData,
        vendor: vendor_id,
      };
      this.props.vendor_reject_pending_diner(
        formData,
        diner_id,
        vendor_id,
        token
      );
      this.onCloseModal();
      this.props.closedMainModal();
    }
  };

  onCancelSuccess = (e) => {
    const formData = {
      vendor_id: this.props.auth.user.VendorUser._id,
      event_id: this.props.getSingleEventInfo._id,
    };
    const token = this.props.auth.user.accessToken;
    this.props.fetch_single_event_rsvp_data_information(
      formData,
      token,
      this.onSuccessCancel,
      this.onError
    );
  };

  onSuccessCancel = (e) => {
    this.onCloseModal();
    this.props.closedMainModal();
  };

  onRejectSuccess = (e) => {
    const formData = {
      vendor_id: this.props.auth.user.VendorUser._id,
      event_id: this.props.getSingleEventInfo._id,
    };
    const token = this.props.auth.user.accessToken;
    this.props.fetch_single_event_pending_data_information(
      formData,
      token,
      this.onSuccess,
      this.onError
    );
  };

  onSuccess = (e) => {
    this.onCloseModal();
    this.props.closedMainModal();
  };

  render() {
    const { open, errors, cancelReservationData } = this.state;
    return (
      <div>
        {this.props.mobile ? (
          <button
            className="btn btn-danger font_10_m popup-cancel-button"
            type="button"
            onClick={() => this.onOpenModal}
            style={{ width: "120px", minHeight: "40px" }}
          >
            {this.props.buttonText}
          </button>
        ) : (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="yesButton"
            onClick={(e) =>
              this.props?.noReason
                ? this.onSubmitHandler(e)
                : this.onOpenModal(e)
            }
            style={{ width: "120px", minHeight: "40px" }}
          />
        )}

        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            // closeButton: "customCloseButtonCalling",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="reusable-popup-header-newstyle">
            <h4>
              {this.props?.reasonText &&
              this.props?.location?.pathname?.toString()?.includes("pending")
                ? "Reason for Rejection"
                : "Reason for Cancellation"}
            </h4>
          </div>
          <div className="reason-for-cancellation p-0">
            <Form>
              <div className="mt-4">
                <SelectBoxMUiInputComponent
                  extraClass={false}
                  selectLabel="Select Reason"
                  name="cancelReservationData"
                  value={this.state.cancelReservationData}
                  onChange={this.onChange}
                  getData={
                    this.props.cancelActionCall === "orderCancelReject"
                      ? orderData
                      : reasonData
                  }
                  errorText={errors.cancelReservationData}
                  errorTrue={errors.cancelReservationData === "" ? true : false}
                />
              </div>
              {cancelReservationData === "Other" ? (
                <NewInputText
                  name="enter_reason"
                  onChange={this.onChange}
                  rows="4"
                  multiline={true}
                  value={this.state.enter_reason}
                  labelText="Enter Reason"
                  controlClass={"outlined-helperText "}
                />
              ) : null}
              <div className="mt-5 d-flex">
                <ReusableOnboardingButton
                  buttonTitle="Cancel Button"
                  buttonClass={
                    "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                  }
                  buttonText="Cancel"
                  onClick={this.onCloseModal}
                  buttonType="button"
                />
                <ReusableOnboardingButton
                  buttonTitle="Save"
                  buttonClass={
                    this.state.cancelReservationData === "" ||
                    (this.state.cancelReservationData === "Other" &&
                      this.state.enter_reason === "")
                      ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                      : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  }
                  buttonText="Save"
                  onClick={
                    this.state.cancelReservationData === "" ||
                    (this.state.cancelReservationData === "Other" &&
                      this.state.enter_reason === "")
                      ? () => {}
                      : this.onSubmitHandler
                  }
                  buttonType="button"
                />
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

ReasonForCancellation.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getSingleEventInfo: state.rsvpEvent.get_single_event_info,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_reject_pending_diner,
  edit_order_vendor_side,
  rejecting_rsvp_event_request,
  fetch_single_event_pending_data_information,
  fetch_single_event_rsvp_data_information,
})(withRouter(ReasonForCancellation));
